// ── Image-input label presets ──────────────────────────────────────────────
// A template stores ONLY the `key` for its image-input label(s). The text shown
// to admins and end-users is resolved from this list per language. To add, rename
// or translate a label, edit this list in one place — nothing else changes.
//
// Each entry: { key, en, bn }. Edit this list to add/rename/translate labels.
export const IMAGE_INPUT_LABELS = [
    { key: 'upload_your_image',    en: 'Upload Your Image',    bn: 'আপনার ছবি আপলোড করুন' },
    { key: 'upload_baby_image',    en: 'Upload Baby Image',    bn: 'বাচ্চার ছবি আপলোড করুন' },
    { key: 'upload_user_image',    en: 'Upload User Image',    bn: 'ব্যবহারকারীর ছবি আপলোড করুন' },
    { key: 'upload_product_image', en: 'Upload Product Image', bn: 'প্রোডাক্টের ছবি আপলোড করুন' },
    { key: 'upload_model_image',   en: 'Upload Model Image',   bn: 'মডেলের ছবি আপলোড করুন' },
    { key: 'upload_image',         en: 'Upload Image',         bn: 'ছবি আপলোড করুন' },
];

// Resolve a stored value (a key from the list above, or — for older templates —
// a literal label) into display text for the given language.
export const resolveImageInputLabel = (keyOrText, lang = 'en') => {
    const preset = IMAGE_INPUT_LABELS.find((x) => x.key === keyOrText);
    if (preset) return lang === 'bn' ? (preset.bn || preset.en) : preset.en;
    return keyOrText || ''; // backward-compat: literal label from an older template
};

// Is this stored value one of our known preset keys?
export const isImageInputLabelKey = (value) =>
    IMAGE_INPUT_LABELS.some((x) => x.key === value);
